module.exports = "<template>\n    <div id=\"sio-schedule-calendar\"></div>\n</template>";